export default "__VITE_PUBLIC_ASSET__e71b5178__"